import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  ChangeDetectorRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { Note } from '../../../../../../shared/modules/notes/notes.types';
import { PanelsInterfaceComponent } from '../panels-interface.component';
import { AddOfferComponent } from 'app/modules/projects/details/offers/add-offer/add-offer.component';
import { Offer } from 'app/modules/projects/details/offers/offers.types';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Property } from 'app/modules/projects/projects.types';
import { PropertyTenantsService } from 'app/modules/properties/details/tenants/tenants.service';
import { AccountService } from 'app/core';

@Component({
  selector: 'project-panel-units',
  templateUrl: './units-table.component.html',
  styleUrls: ['./units-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelsUnitsTableComponent implements PanelsInterfaceComponent, OnInit {
  @Input() project: any;
  @Input() account: any;
  @Input() panelDef: any;
  @Input() data: any;
  @Input() canEditPanelDef = true;
  @Output() onUpdate: EventEmitter<string> = new EventEmitter();
  @Output() onEditPanelDef: EventEmitter<any> = new EventEmitter();

  private _unsubscribeAll: Subject<void>;

  notes: Note[];
  offers: Offer[];
  displayColumns: string[];
  unitDataSource: MatTableDataSource<any>;
  titleFieldDef: any;
  panelName: string;
  editMode: boolean;
  changeTitleMode: boolean = false;
  properties: Property[] = [];
  units: any = [];
  unitLeases: any[] = [];

  constructor(
    private _matDialog: MatDialog,
    private _changeDetectorRef: ChangeDetectorRef,
    private _propertyTenantsService: PropertyTenantsService,
    private _accountService: AccountService,
  ) {
    this._unsubscribeAll = new Subject();
    this.unitDataSource = new MatTableDataSource();
    this.displayColumns = ['name', 'interior_sq_ft', 'site_sq_ft', 'annual_rent', 'lease_start_date', 'lease_end_date'];
  }

  ngOnInit() {
    this.notes = this.project.notes;
    this.properties = [...this.project.properties];

    this._accountService.currentAccount.subscribe((accountData) => {
      this._propertyTenantsService.accountId = accountData.id;
      if (this.properties.length === 1) {
        this._propertyTenantsService.getPropertyUnitsByPropertyId(this.properties[0].id).subscribe((response) => {
          this.units = response['property_units'];
          this.unitLeases = [];
          this.units.forEach((unit) => {
            let interior = unit.custom_field_values.find((cfv) => cfv.name === 'interior_sq_ft');
            let site = unit.custom_field_values.find((cfv) => cfv.name === 'usps_site_sq_ft');
            this.unitLeases.push({
              name: unit.unit_number,
              interior_sq_ft: interior ? interior.val : '',
              site_sq_ft: site ? site.val : '',
              annual_rent: unit.property_tenants[0]?.annual_rent ? unit.property_tenants[0].annual_rent : '',
              lease_end_date: unit.property_tenants[0]?.lease_end_date ? unit.property_tenants[0].lease_end_date : '',
              lease_start_date: unit.property_tenants[0]?.lease_start_date
                ? unit.property_tenants[0].lease_start_date
                : '',
            });
            this.unitDataSource.data = this.unitLeases;

            this._changeDetectorRef.markForCheck();
          });
        });

        this.unitDataSource.data = this.unitLeases;

        this._changeDetectorRef.markForCheck();
      }
    });

    this.titleFieldDef = {
      name: 'panel_name',
      label: this.panelDef.title,
      type: 'text',
    };
  }
  update(params) {
    let currentKey = Object.keys(params)[0];
    if (currentKey === 'panel_name') {
      this.panelName = params.panel_name;
    }
  }

  saveLayout(): void {
    if (this.panelName) {
      this.panelDef.title = this.panelName;
    }
    this.onEditPanelDef.emit(this.panelDef);
    this.toggleEditMode(false);
  }

  toggleChangeTitleMode() {
    this.changeTitleMode = true;
  }

  toggleEditMode(editMode: boolean | null = null): void {
    if (editMode === null) {
      this.editMode = !this.editMode;
    } else {
      this.editMode = editMode;
    }
    this.changeTitleMode = false;

    this._changeDetectorRef.markForCheck();
  }

  openAddOfferModal(): void {
    const dialogRef = this._matDialog.open(AddOfferComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { project: this.project, options: this.data.options },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  openEditOfferModel(offer): void {
    const dialogRef = this._matDialog.open(AddOfferComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { project: this.project, options: this.data.options, offer: offer },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
